import React, { useEffect, useState, useRef } from "react";
import styled from "styled-components";
import outConnect from "../../img/outConnect.png";
import { CaretDownOutlined } from "@ant-design/icons";
import CovPeopleSelect from "./covPeopleSelect";
import api from "../../apis/pc/conversation/conversation";
import userApi from "../../apis/pc/user/user";
import { useSelector } from "react-redux";
import HeadImg from "../../components/common/head-img/headImg";
import LoadMore from "../../components/common/load-more/loadMore";
import { message, Input, Tooltip } from "antd";
import { useUpdateEffect } from "../../hooks/useUpdateEffect";
import { limitString } from "../../utils/utils";
import { getParameterByName, debounce } from "@/utils/utils";
import WxImg from "@/img/wx-img.png"
import LastMessageType from "./lastMessageType";
import { TooltipWrapper } from "@/css/css";

const EmptyWrapper = () => {
  const isIframe = getParameterByName("deviceType") === "iframe";
  if(!isIframe) {
    return <></>
  }
  return <div style={{ textAlign: 'center' }}>暂无记录</div>
}

const { Search } = Input;

const ContactWrapper = styled.div`
  width: 100%;
  padding-right: 0;
`;
const ListLine = styled.div`
  /* margin-bottom: 8px; */
  padding: 8px 24px;
  padding-right: 0;
  width: 336px;
  overflow: hidden;
  ${({ flex }) => flex && `
    display: flex;
  `}
  .contact-list-line{
    padding-left: 4px;
  }
  &.active-line {
    background: #fff2ea !important;
    .contact-list-name {
      padding: 0 4px;
      padding-left: 0;
      line-height: 27px;
      color: #595959;
      overflow: hidden;
    }

    .contact-list-line-group{
      background: #fff2ea !important;
    }
    .group-right{
      color: #595959;
      overflow: hidden;
    }
  }
  .contact-list-img {
    display: inline-block;
  }
  .contact-list-line {
    font-size: 12px;
    display: inline-block;
    min-height: 26px;
    cursor: pointer;
    width: 100%;
    overflow: hidden;
    padding-right: 16px;
    vertical-align: bottom;
    .contact-list-info {
      display: flex;
      overflow: hidden;
      white-space: nowrap;
      text-overflow: ellipsis;
      width: 100%;
      height: 26px;
      margin-top: -1px;
      align-items: center;
    }
    .contact-list-name {
      padding: 0 4px;
      padding-left: 0;
      line-height: 27px;
      color: #595959;
      overflow: hidden;
    }
    .contact-list-companyInfo {
      color: #bfbfbf;
    }
    .label-status {
      display: inline-block;
    }
  }
  
  .contact-list-line-group{
    display: flex;
    flex-wrap: wrap;
    padding-right: 16px;
    overflow: hidden;
    flex: 1;
    .last-message-line{
      width: 100%;
    }
    .group-inner{
      flex-wrap: wrap;
      flex: 1;
      overflow: hidden;
      padding-left: 4px;
    }
    .group-right{
      display: flex;
      flex-direction: column;
      font-size: 12px;
      span.contact-right-name{
          height: 26px;
          line-height: 26px;
          width: 100%;
          font-size: 14px;
      }
      span{
        display: block;
      }

      .contact-right-name{
        color: #595959;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        display: block;
        font-size: 14px;
        span{
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
          display: block;
        }
      }

      .group-right-name{
        color: #BFBFBF;
      }
    }
  }
`;
const DeleteLabel = styled.span`
  display: inline-block;
  background: rgba(151, 109, 208, 0.1);
  color: #976dd0;
  font-size: 12px;
  margin-left: 8px;
  padding: 2px 4px;
  margin-top: 2px;
`;
const OutLabel = styled.span`
  display: inline-block;
  background: #fef2f7;
  color: #f77fb3;
  font-size: 12px;
  margin-left: 8px;
  padding: 2px 4px;
  margin-top: 2px;
`;
const ListContent = styled.div`
  cursor: pointer;
  .contact-list-wximg{
    width: 44px;
    height: 44px;
    align-self: center;
  }
`;
const CurrentPeople = styled.div`
  margin-left: 24px;
  margin-top: 24px;
  .people-name {
    margin: 0 8px;
    font-size: 14px;
    color: #595959;
    cursor: pointer;
  }
`;
const ListTypeDiv = styled.div`
  padding: 24px 0 8px;
  margin-left: 24px;

  span{
    border-radius: 2px;
    border: 1px solid #D9D9D9;
    font-size: 12px;
    margin-right: 8px;
    cursor: pointer;
    height: 24px;
    display: inline-block;
    padding: 0 8px;
    line-height: 22px;
  }

  .active-btn{
    color: #FFFFFF;
    background: #FF9052;
    line-height: 24px;
    border: 0;
  }
`
const SearchDiv = styled(Search)`
  width: 288px;
  height: 24px;
  margin-bottom: 8px;
  margin-left: 24px;

  .ant-input-wrapper{
    input{
      height: 24px;
    }

    button{
      height: 24px;
    }
  }
`;

const ListScroll = styled.div`
  overflow-x: hidden;
  overflow-y: auto;
`

const NameLine = styled.div`
  align-items: center;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  display: block;
  font-size: 14px;
`

const ListTypeBtn = [
  { name: "外部好友", key: "1" },
  { name: "内部好友", key: "3" },
  { name: "外部群", key: "2" },
  { name: "内部群", key: "4" }
]
const ContactList = (props) => {
  const { handleChange, session, loading, searchCondition } = props;
  const chageAndType = (data) => {
    setClieckType(String(data?.sessionType))
    dataRef.clieckType = data?.sessionType
  }
  const [showSelect, setShowSelect] = useState(false); // 是否员工选择框
  const [outPeopleCondition, setOutPeopleCondition] = useState({
    pageSize: 20,
    chatType: 1,
    pageNum: 1,
  });//外部好友
  const [innerUserCondition, setInnerUserCondition] = useState({
    pageSize: 20,
    chatType: 3,
    pageNum: 1,
  });//内部好友
  const [outGroupCondition, setOutGroupCondition] = useState({
    pageSize: 20,
    chatType: 2,
    pageNum: 1,
  });//外部群
  const [innerGroup, setInnerGroup] = useState({
    pageSize: 20,
    chatType: 4,
    pageNum: 1,
  })//内部群
  const [outConnection, setOutConnection] = useState({ list: [], total: 0 }); // 企微客户列表对象
  const [innerUser, setInnerUser] = useState({ list: [], total: 0 }); // 内部好友列表对象
  const [outGroup, setOutGroup] = useState({ list: [], total: 0 }); // 外部群列表对象
  const [innerGroupList, setInnerGroupList] = useState({ list: [], total: 0 }); // 内部群列表对象
  const currentUser = useSelector((state) => state.userInfo.userInfo); // 当前登录用户信息
  const [operateData, setOperateData] = useState({}); // 当前查看的用户
  const [defaultData, setDefaultData] = useState([]); // 当前查看的用户
  const [checkValue, setCheckValue] = useState({ value: "", name: "" });
  const selectref = useRef(null);
  const [clieckType, setClieckType] = useState("1");
  const [searchNameParam, setSearchNameParam] = useState("");
  const dataRef = useRef({clieckType: "1"}).current
  const nowDate = new Date()
  const month = nowDate.getMonth() + 1
  const date = nowDate.getDate()

  useUpdateEffect(() => {
    props?.getUserList && props?.getUserList({
      innerUser: innerUser?.list || [],
      outGroup: outGroup?.list || [],
      innerGroupList: innerGroupList?.list || [],
      outConnection: outConnection?.list || [],
      clieckType
    });
  }, [innerUser, outGroup, innerGroupList, outConnection, clieckType])

  const ContactState = (props) => {
    const { type } = props;
    switch (type) {
      case 1:
        return null;
      case 2:
        return <DeleteLabel>已删除</DeleteLabel>;
      case 3:
        return <OutLabel>未允许</OutLabel>;
      default:
        return null;
    }
  };

  const selectChange = (value) => {
    setShowSelect(false);
    setCheckValue({ value: "", name: "" })
    setOperateData({ uid: value.value, name: value.name });
  };

  // 获取企微客户列表
  const getOutConnectList = (params, reset) => {
    let type = getParameterByName("deviceType") === "iframe" ? 2 : 1;
    let crmCustomerId = getParameterByName("id");
    let obj = {
      uid: params.uid, type, crmCustomerId, ...outPeopleCondition, ...searchCondition, searchNameParam: searchNameParam
    }
    if (reset) {
      obj.pageNum = 1;
      setOutPeopleCondition({...outPeopleCondition, pageNum: 1})
    }

    if (!props.selectFlag) {
      delete obj.uid
    }
    return api
      .externalList(obj)
      .then((res) => {
        const { code, data } = res;
        if (code === 0) {
          return data;
        }
      });
  };

  // 获取内部好友列表
  const getInnerUsertList = (params, reset) => {
    let type = getParameterByName("deviceType") === "iframe" ? 2 : 1;
    let crmCustomerId = getParameterByName("id");
    let obj = {
      uid: params.uid, type, crmCustomerId, ...innerUserCondition, ...searchCondition, searchNameParam: searchNameParam
    }
    if (reset) {
      obj.pageNum = 1;
      setInnerUserCondition({...innerUserCondition, pageNum: 1})
    }

    if (!props.selectFlag) {
      delete obj.uid
    }
    return api
      .innerUserList(obj)
      .then((res) => {
        const { code, data } = res;
        if (code === 0) {
          return data;
        }
      });
  };

  // 获取外部群列表
  const getOutGroupList = (params, reset) => {
    let type = getParameterByName("deviceType") === "iframe" ? 2 : 1
    let crmCustomerId = getParameterByName("id");
    let obj = {
      uid: params.uid, type, crmCustomerId, ...outGroupCondition, ...searchCondition, searchNameParam: searchNameParam
    }
    if (reset) {
      obj.pageNum = 1;
      setOutGroupCondition({...outGroupCondition, pageNum: 1})
    }

    if (!props.selectFlag) {
      delete obj.uid
    }
    return api
      .externalGroupList(obj)
      .then((res) => {
        const { code, data } = res;
        if (code === 0) {
          return data;
        }
      });
  };

  // 获取内部群列表
  const getInnerGroupList = (params, reset) => {
    let type = getParameterByName("deviceType") === "iframe" ? 2 : 1
    let crmCustomerId = getParameterByName("id");
    let obj = {
      uid: params.uid, type, crmCustomerId, ...innerGroup, ...searchCondition, searchNameParam: searchNameParam
    }
    if (reset) {
      obj.pageNum = 1;
      setInnerGroup({...innerGroup, pageNum: 1})
    }

    if (!props.selectFlag) {
      delete obj.uid
    }
    return api
      .externalGroupList(obj)
      .then((res) => {
        const { code, data } = res;
        if (code === 0) {
          return data;
        }
      });
  };

  // crm客户详情下员工列表
  const getCurrentUserEnableByIframe = (crmContactId, data, crmCustomerId, whiteList) => {
    const crmContactIds = crmContactId.split(',')?.filter(item => item)?.map(item => Number(item))
    // reallyOid iframe下 只有top下有current_org
    const reallyOid = process.env.NODE_ENV === 'development' ? process.env?.OID : window?.top?.current_org?.oid
    const params = { oid: reallyOid, contactIds: crmContactIds,  }
    if (whiteList) {
      // 灰度名单中的新crm 好友
      params.crmCustomerId = crmCustomerId
    } else {
      const crmContactIds = crmContactId.split(',')?.filter(item => item)?.map(item => Number(item))
      if(crmContactIds?.length < 1) {
        return
      } else {
        params.contactIds = crmContactIds
      }
    }

    userApi.getCovUsersByIframe(params).then(response => {
      if (response.code === 0) {
        if (response.data.length > 0) {
          setOperateData(response.data[0]);
          setDefaultData(response.data);
        }
      } else {
        message.warning(
          response.message
        );
      }
    }).catch(err => {
      message.error(err?.message)
    })
  }

  // 查询当前员工是否开通了消息存档
  const getCurrentUserEnable = () => {
    api.getCurrentUserEnable({ uid: currentUser.uid, oid: currentUser.oid }).then((res) => {
      const { code, data } = res;
      if (code === 0) {
        // iframe是客户详情下的企微聊天记录tab 这里的员工列表使用另外一个接口
        let type = getParameterByName("deviceType") === "iframe" ? 2 : 1
        let crmContactId = getParameterByName("contactsIds", true);
        let scrmFriend = getParameterByName("scrm_friend", true); // 是否是新版的crm好友
        let crmCustomerId = getParameterByName("id");
        if(type === 2){
          getCurrentUserEnableByIframe(crmContactId, data, crmCustomerId, scrmFriend)
          return
        }
        userApi.getCovUsers([]).then((response) => {
          if (response.code === 0) {
            if (response.data.length > 0) {
              // 默认选择列表中的第一条
              setOperateData(response.data[0]);
              setDefaultData(response.data);
            }
          }else {
            message.warning(
              response.message
            );
          }
        });
      }
    });
  };

  // 处理选择框失焦
  const handleBlur = () => {
    setCheckValue({ value: "", name: "" })
    setShowSelect(false);
  };

  useEffect(() => {
    if (currentUser.uid) {
      getCurrentUserEnable();
    }
  }, [currentUser]);

  useEffect(() => {
    if (operateData.uid) {
      props.handleSetUid(operateData.uid)
      Promise.all([
        getOutConnectList(operateData, 1),
        getOutGroupList(operateData, 1),
        getInnerGroupList(operateData, 1),
        getInnerUsertList(operateData, 1)
      ]).then(([people, group, innerGroup, innerUser]) => {
        const outUserList = people?.list || []
        const innerUserList = innerUser?.list || []
        const outGroupList = group?.list || []
        const innerGroupList = innerGroup?.list || []
        const findItem = [...outUserList, ...innerUserList, ...outGroupList, ...innerGroupList]?.[0]
        if(findItem && 'content' in searchCondition) {
          setOutConnection(people);
          setInnerUser(innerUser)
          setOutGroup(group);
          setInnerGroupList(innerGroup)
          handleChange({ setType: "session", ...findItem });
          chageAndType({ setType: "session", ...findItem })
        }
        else if('content' in searchCondition && !findItem) {
          setOutConnection(people);
          setInnerUser(innerUser)
          setOutGroup(group);
          setInnerGroupList(innerGroup)
          handleChange({ setType: 'clear' })
        }
      })
    }
  }, [searchCondition])

  useEffect(() => {
    if (operateData.uid) {
      props.handleSetUid(operateData.uid)
      Promise.all([
        getOutConnectList(operateData, 1),
        getOutGroupList(operateData, 1),
        getInnerGroupList(operateData, 1),
        getInnerUsertList(operateData, 1)
      ]).then(([people, group, innerGroup, innerUser]) => {
        // 替换掉老的逻辑
        const outUserList = people?.list || []
        const innerUserList = innerUser?.list || []
        const outGroupList = group?.list || []
        const innerGroupList = innerGroup?.list || []
        setOutConnection(people);
        setInnerUser(innerUser)
        setOutGroup(group);
        setInnerGroupList(innerGroup)
        if(outUserList?.length > 0 && +dataRef.clieckType === 1) {
          handleChange({ setType: "session", ...outUserList?.[0] });
          return
        }
        if(innerUserList?.length > 0 && +dataRef.clieckType === 3) {
          handleChange({ setType: "session", ...innerUserList[0] });
          return
        }
        if(outGroupList?.length > 0 && +dataRef.clieckType === 2) {
          handleChange({ setType: "session", ...outGroupList?.[0] });
          return
        }
        if(innerGroupList?.length > 0 && +dataRef.clieckType === 4) {
          handleChange({ setType: "session", ...innerGroupList[0] });
          return
        }
        // 默认选择第一个
        // 外部好友与外部好友有值
        // if (people && people?.list.length) {
        //   let peopleid = props.pathParms[props.pathParms.length - 1]
        //   if (peopleid === "conversation") {
        //     handleChange({ setType: "session", ...people?.list[0] });
        //     chageAndType({ setType: "session", ...people?.list[0], reset: searchCondition.reset })
        //   } else {
        //     //当消息存档页有传ID时，根据ID选中对应联系人查看聊天记录，这一期需求有所更改，目前先不会走这个判断
        //     // let obj = {}
        //     // people?.list.forEach(res => {
        //     //   if (res.sessionId === Number(peopleid)) {
        //     //     obj = { setType: "session", ...res }
        //     //   }
        //     // })
        //     // if (Object.keys(obj).length == 0) {
        //     //   group?.list.forEach(res => {
        //     //     if (res.sessionId === Number(peopleid)) {
        //     //       obj = { setType: "session", ...res }
        //     //     }
        //     //   })
        //     // }
        //     // handleChange(obj);
        //   }
        // } else if (
        //   people &&
        //   people?.list.length === 0 &&
        //   group &&
        //   group?.list.length &&
        //   innerGroup &&
        //   innerGroup?.list.length &&
        //   innerUser &&
        //   innerUser?.list.length
        // ) {
        //   // 外部好友没值 外部群有值 内部群与内部群有值 内部好友与内部好友有值
        //   handleChange({ setType: "session", ...group?.list[0] });
        //   chageAndType({ setType: "session", ...group?.list[0], reset: searchCondition.reset })
        // } else if (
        //   people &&
        //   people?.list.length === 0 &&
        //   group &&
        //   group?.list.length === 0 &&
        //   innerGroup &&
        //   innerGroup?.list.length &&
        //   innerUser &&
        //   innerUser?.list.length
        // ) {
        //   // 外部好友没值 外部群没值 内部群与内部群有值 内部好友与内部群有值
        //   let sessionId = null
        //   // 1 外部好友 2 外部群 3 内部好友 4内部群
        //   if(innerGroup?.list?.length && +dataRef.clieckType === 4) {
        //     sessionId = innerGroup?.list?.[0]?.sessionId
        //   }
        //   if(group?.list?.length && +dataRef.clieckType === 2) {
        //     sessionId = group?.list?.[0]?.sessionId
        //   }
        //   if(innerUser?.list?.length && +dataRef.clieckType === 3) {
        //     sessionId = innerUser?.list?.[0]?.sessionId
        //   }
        //   handleChange({ setType: "session", sessionId });
        // } else {
        //   let sessionId = null
        //   // 1 外部好友 2 外部群 3 内部好友 4内部群
        //   if(innerGroup?.list?.length && +dataRef.clieckType === 4) {
        //     sessionId = innerGroup?.list?.[0]?.sessionId
        //   }
        //   if(group?.list?.length && +dataRef.clieckType === 2) {
        //     sessionId = group?.list?.[0]?.sessionId
        //   }
        //   handleChange({ setType: "session", sessionId });
        //   chageAndType({ setType: "session", sessionId: innerGroup?.list?.length ? innerGroup?.list?.[0]?.sessionId : null, ...(innerGroup?.list?.[0] || group.list?.[0])});
        // }
        // setOutConnection(people);
        // setInnerUser(innerUser)
        // setOutGroup(group);
        // setInnerGroupList(innerGroup)
      });
    }
  }, [operateData, searchNameParam]);

  useUpdateEffect(() => {
    if (outPeopleCondition.pageNum === 1) return;
    let temp = JSON.parse(JSON.stringify(outConnection));
    getOutConnectList(operateData).then((res) => {
      setOutConnection({
        nextPage: res?.nextPage,
        list: temp?.list.concat(res?.list),
      });
    });
  }, [outPeopleCondition]);

  useUpdateEffect(() => {
    if (innerUserCondition.pageNum === 1) return;
    let temp = JSON.parse(JSON.stringify(innerUser));
    getInnerUsertList(operateData).then((res) => {
      setInnerUser({
        nextPage: res?.nextPage,
        list: temp?.list.concat(res?.list),
      });
    });
  }, [innerUserCondition]);

  useUpdateEffect(() => {
    if (outGroupCondition.pageNum === 1) return;
    let temp = JSON.parse(JSON.stringify(outGroup));
    getOutGroupList(operateData).then((res) => {
      setOutGroup({
        nextPage: res?.nextPage,
        list: temp?.list.concat(res?.list),
      });
    });
  }, [outGroupCondition]);

  useUpdateEffect(() => {
    if (innerGroup.pageNum === 1) return;
    let temp = JSON.parse(JSON.stringify(innerGroupList));
    getInnerGroupList(operateData).then((res) => {
      setInnerGroupList({
        nextPage: res?.nextPage,
        list: temp?.list.concat(res?.list),
      });
    });
  }, [innerGroup]);

  useEffect(() => {
    if (showSelect) {
      selectref.current.querySelector("input").focus();
    }
  }, [showSelect])

  useUpdateEffect(() => {
    setShowSelect(props.selectFlag)
    // setOutPeopleCondition({ uid: "" })
    // setInnerUserCondition({ uid: "" })
    // setOutGroupCondition({ uid: "" })
    // setInnerGroup({ uid: "" })
  }, [props.selectFlag]);

  const onSearchInput = (val) => {
    setSearchNameParam(val)
  }

  const handleInput = debounce(onSearchInput, 450);

  const renderName = (record = {}, params = {}) => {
    const length = [2, 3].includes(record?.status) ? 8 : 15
    const { extendUserInfo = '' } = record
    const { corp } = params
    const [name, corpName] = extendUserInfo?.split('@')
    // 如果该好友的账号类型为企微，则展示：好友姓名（备注）@该好友的所属公司；如果该员工对其好友没有备注或“备注”与“姓名”一致，则不展示备注
    // 如果该好友的账号类型为个微，则展示：好友昵称（备注）@微信；如果该员工对其好友没有备注或“备注”与“昵称”一致，则不展示备注
    const realName = record?.innerUserInfo ? record?.innerUserInfo : extendUserInfo
    const Wrapper = realName?.length >= length ? Tooltip : React.Fragment
    return (
      <Wrapper title={realName} color='#fff'>
        <NameLine className='user-name'>
          {record?.innerUserInfo ? record?.innerUserInfo : name}
          { corp && renderFrom(record) }
        </NameLine>
      </Wrapper>
    );
  };

  const renderFrom = (record) => {
    const [name, corpName] = String(record?.extendUserInfo)?.split('@')
    const color = corpName === '微信' ? '#52C41A' : '#FF9052'
    return <span style={{ color, marginLeft: '4px', fontSize: '12px' }}>
      @{ corpName }
    </span>
  }

  const renderRoomName = (item) => {
    const Wrapper = item.roomName?.length >= 15 ? Tooltip : React.Fragment;
    return (
      <Wrapper color='#fff' title={item.roomName}>
        {item.roomName}
      </Wrapper>
    );
  };

  const onLoadMore = () => {
    if (clieckType === "1") {
      setOutPeopleCondition({
        ...outPeopleCondition,
        pageNum: outPeopleCondition.pageNum + 1,
      });
    } else if (clieckType === "2") {
      setOutGroupCondition({
        ...outGroupCondition,
        pageNum: outGroupCondition.pageNum + 1,
      });
    } else if (clieckType === "3") {
      setInnerUserCondition({
        ...innerUserCondition,
        pageNum: innerUserCondition.pageNum + 1,
      });
    } else if (clieckType === "4") {
      setInnerGroup({
        ...innerGroup,
        pageNum: innerGroup.pageNum + 1,
      });
    }
  }

  return (
    <ContactWrapper>
      <TooltipWrapper />
      {
        props.selectFlag ? <>
          {!showSelect && operateData.name && (
            <CurrentPeople onClick={() => setShowSelect(true)}>
              <HeadImg
                url={operateData.avatarUrl}
                name={operateData.name}
                width={24}
                height={24}
              />
              <span className={"people-name"}>{operateData.name}</span>
              <CaretDownOutlined
                style={{ color: "#D8D8D8", width: "12px", cursor: "pointer" }}
              />
            </CurrentPeople>
          )}
          <div
            ref={selectref}
            style={showSelect ? {marginLeft: '24px', marginTop: '24px'} : { display: "none" }}
          >
            <CovPeopleSelect
              // defaultValue={{value: JSON.stringify({id: operateData.uid, name: operateData.name})}}
              handleBlur={() => handleBlur()}
              checkValue={checkValue}
              open={showSelect}
              handleSuccess={selectChange}
              defaultData={defaultData}
            />
          </div>
        </> : ""
      }

      <ListTypeDiv>
        {
          ListTypeBtn?.map((res) => (
            <span key={res.key} className={clieckType === res.key ? "active-btn" : ""}
                  onClick={() => {
                    setClieckType(res.key)
                    dataRef.clieckType = res.key
                    props.handleChatType(res.key)
                    if (res.key === "1") {
                      handleChange({ setType: "session", ...outConnection?.list[0] });
                    } else if (res.key === "2") {
                      handleChange({ setType: "session", ...outGroup?.list[0] });
                    } else if (res.key === "3") {
                      handleChange({ setType: "session", ...innerUser?.list[0] });
                    } else {
                      handleChange({ setType: "session", ...innerGroupList?.list[0] });
                    }
                  }}
            >
              {res.name}
            </span>
          ))
        }
      </ListTypeDiv>

      <SearchDiv
        style={clieckType === "2" ? { marginBottom: "8px" } : {}}
        placeholder={["2", "4"].includes(clieckType) ? "搜索群名称" : "搜索好友昵称/备注"}
        autoComplete={"false"}
        onSearch={(e) => {
          onSearchInput(e)
        }}
        onChange={(e) => {
          handleInput(e.target.value)
        }}
      />


      {/*外部好友*/}
      {clieckType === "1" ? (
        <ListContent>
          <ListScroll>
            {outConnection?.list?.length > 0 ? outConnection && outConnection?.list?.map((item) => {
              return (
                <ListLine
                  key={item.sessionId}
                  flex={true}
                  onClick={() => handleChange({ setType: 'session', ...item })}
                  className={
                    session.sessionId === item.sessionId
                      ? 'active-line'
                      : 'list-line'
                  }
                >
                  {/* <div className={'contact-list-img'}> */}
                  <HeadImg
                    url={item.userImg ? item.userImg : item.extendUserImg}
                    name={
                      item.extendUserRemark
                        ? item.extendUserRemark
                        : item.extendUserName
                    }
                    width={44}
                    height={44}
                  />
                  {/* </div> */}

                  <div className={'contact-list-line'}>
                    <div className={'contact-list-info'}>
                      { renderName(item, { corp: true }) }
                      <div className={'label-status'} style={{ marginLeft: 'auto' }}>
                        <ContactState type={item.status} />
                      </div>
                    </div>
                    <LastMessageType data={item} />
                  </div>
                </ListLine>
              );
            }) : <EmptyWrapper />}
          </ListScroll>
          {/*pageType为2表示下拉，3表示向上加载*/}
          {outConnection && outConnection?.nextPage && (
            <LoadMore onClick={onLoadMore} />
          )}
        </ListContent>
      ) : null}

      {/* 内部好友 */}
      {clieckType === "3" ? (
        <ListContent>
          <ListScroll>
            {innerUser?.list?.length > 0 ? innerUser?.list?.map((item) => {
              return (
                <ListLine
                  key={item.sessionId}
                  flex={true}
                  onClick={() => handleChange({ setType: "session", ...item })}
                  className={
                    session.sessionId === item.sessionId
                      ? "active-line"
                      : "list-line"
                  }
                >
                  <div className={"contact-list-img"}>
                    <HeadImg url={item.userImg ? item.userImg : item.toUserImg}
                             name={item.extendUserRemark ? item.extendUserRemark : item.toUserName}
                             width={44}
                             height={44}
                    />
                  </div>

                  <div className={"contact-list-line"}>
                    <div className={"contact-list-info"}>
                      <span className={"contact-list-name"}>
                      { renderName(item) }
                        {/* {item.extendUserRemark ? item.extendUserRemark : item.toUserName} */}
                      </span>
                      {item.corpName && (
                        <span className={"contact-list-companyInfo"}>
                          @{item.corpName}
                        </span>
                      )}
                    </div>
                    <LastMessageType data={item}  />
                  </div>
                </ListLine>
              );
            }) : <EmptyWrapper />}
          </ListScroll>
          {/*pageType为2表示下拉，3表示向上加载*/}
          {innerUser?.nextPage && (
            <LoadMore
              onClick={() => {
                setInnerUserCondition({
                  ...innerUserCondition,
                  pageNum: innerUserCondition.pageNum + 1,
                });
              }}
            />
          )}
        </ListContent>
      ) : null}

      {/* 外部群 */}
      {clieckType === "2" ? (
        <ListContent>
          <ListScroll>
            {outGroup?.list?.length > 0 ? outGroup?.list?.map((item) => (
              <div key={item.sessionId}>
                <ListLine
                  flex={true}
                  onClick={() => {
                    if (loading) {
                      message.warning("请求数据中,请稍后再试")
                    } else {
                      handleChange({ setType: "session", ...item })
                    }
                  }
                  }
                  className={
                    session.sessionId === item.sessionId
                      ? "active-line"
                      : "list-line"
                  }
                >
                  <img src={WxImg} className="contact-list-wximg" />
                  <div className={"contact-list-line-group"}>
                    <div className="group-right group-inner">
                      <span className={"contact-right-name"}>
                        {renderRoomName(item)}
                      </span>
                      <LastMessageType data={item} />
                    </div>
                  </div>
                  {/*<ContactState type={3}/>*/}
                </ListLine>
              </div>
            )) : <EmptyWrapper />}
          </ListScroll>
          {/*pageType为2表示下拉，3表示向上加载*/}
          {outGroup?.nextPage && (
            <LoadMore
              onClick={() => {
                setOutGroupCondition({
                  ...outGroupCondition,
                  pageNum: outGroupCondition.pageNum + 1,
                });
              }}
            />
          )}
        </ListContent>
      ) : null}

      {/* 内部群 */}
      {
        clieckType === "4" ? (
          <ListContent>
            <ListScroll>
              {innerGroupList?.list?.length > 0 ? innerGroupList?.list?.map((item) => (
                <div key={item.sessionId}>
                  <ListLine
                    flex={true}
                    onClick={() => {
                      if (loading) {
                        message.warning("请求数据中,请稍后再试")
                      } else {
                        handleChange({ setType: "session", ...item })
                      }
                    }
                    }
                    className={
                      session.sessionId === item.sessionId
                        ? "active-line"
                        : "list-line"
                    }
                  >
                    <div className={"contact-list-line-group"}>
                      <img src={WxImg} className="contact-list-wximg" />
                      <div className="group-right group-inner">
                        <span className={"contact-right-name"}>
                          {renderRoomName(item)}
                        </span>
                        <LastMessageType data={item} />
                      </div>
                    </div>
                    {/*<ContactState type={3}/>*/}
                  </ListLine>
                </div>
              )) : <EmptyWrapper />}
            </ListScroll>
            {/*pageType为2表示下拉，3表示向上加载*/}
            {innerGroupList?.nextPage && (
              <LoadMore
                onClick={() => {
                  setInnerGroup({
                    ...innerGroup,
                    pageNum: innerGroup.pageNum + 1,
                  });
                }}
              />
            )}
          </ListContent>
        ) : null}
    </ContactWrapper>
  );
};

export default ContactList;
